module.exports = __webpack_public_path__ + "static/media/shashi.6c7d57d6.jpeg";